import React from 'react'

export default function Screen(props) {
  return (
    <div
      {...props}

      style={{
        padding: '1rem',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        height: '100%',
        overflow: 'auto',
        ...props.style,
      }}
    />
  )
}